(function () {
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-cart-cross-sell-prev], [data-cart-cross-sell-next], [data-cart-cross-sell-add]');
    if (!control) return;

    var section = control.closest('[data-cart-cross-sell]');
    if (!section) return;

    var track = section.querySelector('[data-cart-cross-sell-track]');
    if (control.hasAttribute('data-cart-cross-sell-prev') || control.hasAttribute('data-cart-cross-sell-next')) {
      var card = track.querySelector('.CartCrossSell__Card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var direction = control.hasAttribute('data-cart-cross-sell-next') ? 1 : -1;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      return;
    }

    var variantId = Number(control.getAttribute('data-cart-cross-sell-add'));
    if (!variantId || control.disabled) return;
    control.disabled = true;
    var message = section.querySelector('[data-cart-cross-sell-message]');
    message.hidden = true;

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not add this item. Please try again.');
      document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
    }).catch(function (error) {
      message.textContent = error.message;
      message.hidden = false;
      control.disabled = false;
    });
  });
}());
